import { render, staticRenderFns } from "./TitleSlicerBarPreview.vue?vue&type=template&id=80aafd36&scoped=true"
import script from "./TitleSlicerBarPreview.vue?vue&type=script&lang=js"
export * from "./TitleSlicerBarPreview.vue?vue&type=script&lang=js"
import style0 from "./TitleSlicerBarPreview.vue?vue&type=style&index=0&id=80aafd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aafd36",
  null
  
)

export default component.exports